import { Card, Col, Row } from 'antd';
import React from 'react';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";

import UserOvertime from './AddUserOverTime';
import UserOvertimeData from './getUserOvertime';

const LogOvertime = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		
		<>
	<PageTitle title='Back' />
    <Row gutter={4}>
      <Col span={8}>
        <Card title="Overtime">
          <UserOvertime />
        </Card>
      </Col>
      <Col span={16}>
        <Card title="Overtime Log">
          <UserOvertimeData />
        </Card>
      </Col>
    </Row>
	</>
	);
};

export default LogOvertime;
